// @ts-ignore
import vertexShader from '@/ts/utils/webgl/shaders/sphere/sphere.vert';
// @ts-ignore
import fragmentShader from '@/ts/utils/webgl/shaders/sphere/sphere.frag';
// @ts-ignore
import * as THREE from 'three';

import { BaseScene } from '@/ts/utils/webgl/core/baseScene';
import { Box3, DoubleSide, Mesh, MeshToonMaterial, PlaneGeometry, RawShaderMaterial, Raycaster, SphereGeometry, Vector2, Vector3 } from 'three';

const shaderMaterial = new RawShaderMaterial({
    vertexShader,
    fragmentShader,
    wireframe: false,
    uniforms: {
        uFrequency: { value: new Vector2(20.0, 5.0) },
        uAmplitude: { value: new Vector2(0.1, 0.1) },
        uTime: { value: 0.0 },
    },
});
const rayCast = new Raycaster();
const mousePosition = new Vector2();
const dragPosition = new Vector3();

export class SphereScene extends BaseScene {
    id = 'sphereScene';

    async meshes() {
        const sphere = new Mesh(new SphereGeometry(1, 32, 32), shaderMaterial);
        const plane = new Mesh(
            new PlaneGeometry(10, 10, 40, 40),
            new MeshToonMaterial({
                color: 'teal',
                side: DoubleSide,
            })
        );
        sphere.position.set(0, 2, 0);
        sphere.castShadow = true;
        plane.rotation.set(-Math.PI / 2, 0, 0);
        plane.receiveShadow = true;

        const boundingBox = new Box3().setFromObject(sphere);
        const dimensions = new Vector3();
        const sphereSize = boundingBox.getSize(dimensions); // Returns Vector3
        let isDraggable = false;

        this.loadChain.actors.push([plane]);
        this.loadChain.actors.push([
            sphere,
            {
                id: 'event',
                effect: () => {
                    this.$canvas.addEventListener('mousedown', ev => {
                        if (!isDraggable) {
                            sphere.material.opacity = 0.5;
                            rayCast.setFromCamera(mousePosition, this._camera);
                            isDraggable = !!rayCast.intersectObjects([sphere]).length;
                        } else {
                            isDraggable = false;
                        }
                    });
                    this.$canvas.addEventListener('mousemove', ev => {
                        const x = (ev.clientX / this.$canvas.clientWidth) * 2 - 1;
                        const y = -(ev.clientY / this.$canvas.clientHeight) * 2 + 1;
                        mousePosition.copy({ x, y });

                        if (isDraggable) {
                            rayCast.setFromCamera(mousePosition, this._camera);
                            const intersects = rayCast.intersectObjects([plane]);
                            if (intersects.length > 0) {
                                const intersect = intersects[0];
                                dragPosition.copy(intersect.point);
                            }
                        }
                    });
                },
            },
            {
                id: 'animation',
                effect: () => {
                    sphere.position.set(dragPosition.x, dragPosition.y + sphereSize.y / 2, dragPosition.z);
                },
            },
        ]);
    }

    async gui() {
        await super.gui();
        if (this._gui) {
            this._gui.ctrl.addBinding(shaderMaterial, 'wireframe', {
                label: 'Wireframe',
            });

            const folderX = this._gui.ctrl.addFolder({
                title: 'Noise',
                expanded: true,
            });

            folderX.addBinding(shaderMaterial.uniforms.uFrequency, 'value', {
                label: 'Frequency',
                min: -100,
                max: 100,
                step: 0.1,
            });

            folderX.addBinding(shaderMaterial.uniforms.uAmplitude, 'value', {
                label: 'Amplitude',
                min: -0.5,
                max: 0.5,
                step: 0.05,
            });
        }
    }

    render() {
        shaderMaterial.uniforms.uTime.value = this.clock.getElapsedTime();
        super.render();
    }
}
